import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { policyGroups } from "./policyCatalog";
import "../css/privacy.scss";

const corePolicies = [
  { path: "/terms", title: "Terms & Conditions" },
  { path: "/privacy", title: "Privacy Policy" },
  { path: "/cookies", title: "Cookie Policy" },
  { path: "/shipping", title: "Delivery Policy" },
  { path: "/returns", title: "Returns & Refunds Policy" },
];

function PolicyCenter() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="privacy">
      <Header />
      <main className="main-content full-width inner-page">
        <div className="pdh-page pdh-policy-page policy-center">
          <h1 className="pdh-policy-title">Pawluna Policy Center</h1>
          <div className="pdh-policy-intro-box">
            <p>
              Find information about shopping, privacy, product safety, website use, and
              responsible business practices. Contact many@pawluna.art if you need a policy
              in an accessible alternative format.
            </p>
          </div>
          <section className="policy-center-group">
            <h2>Core Store Policies</h2>
            <div className="policy-center-grid">
              {corePolicies.map((policy) => (
                <Link key={policy.path} to={policy.path} onClick={toTop}>
                  {policy.title}
                </Link>
              ))}
            </div>
          </section>
          {policyGroups.map((group) => (
            <section className="policy-center-group" key={group.title}>
              <h2>{group.title}</h2>
              <div className="policy-center-grid">
                {group.items.map((policy) => (
                  <Link key={policy.path} to={`/${policy.path}`} onClick={toTop}>
                    {policy.title}
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PolicyCenter;
